import { __rest, __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { styles } from './ModalBody.styles.js';
import { classNames } from '../../../../utils/common/styling.js';

var ModalBody = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", __assign({ className: classNames(styles.root, className) }, rest), children));
};

export { ModalBody as default };
//# sourceMappingURL=ModalBody.js.map
